import { render, staticRenderFns } from "./TrayProductOptions.vue?vue&type=template&id=31e42c45"
import script from "./TrayProductOptions.vue?vue&type=script&lang=js"
export * from "./TrayProductOptions.vue?vue&type=script&lang=js"
import style0 from "./TrayProductOptions.vue?vue&type=style&index=0&id=31e42c45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports